const dateRaisedFormatter = new Intl.DateTimeFormat('en-GB')

export const formatDateRaised = (isoDate: string) =>
  dateRaisedFormatter.format(new Date(isoDate))
